module.exports = {
  QuickSearchAdNumber: '快捷检索:广告编号',
  Remove: '下架',
  Publish: '发布',
  AdNumber: '广告编号',
  SubjectName: '主题/名称',
  AdContent: '广告内容',
  Advertiser: '广告主体',
  AdPosition: '广告位',
  BelongToPage: '所属页面',
  BelongToModule: '所属模块',
  BelongToSystem: '所属系统',
  Status: '状态',
  TargetAudience: '投放对象',
  Global: '全局',
  Creator: '创建人',
  CreationDate: '创建日期',
  Modifier: '修改人',
  ModificationDate: '修改日期',
  PromotionPeriod: '推广周期',
  EffectiveTime: '生效时间',
  ExpirationTime: '失效时间',
  PleaseCheckOneEntry: '请勾选一条数据！',
  ContainsUnremovedData: '包含未下架数据！',
  AreYouWantToDelete: '确定要删除吗?',
  PleaseSelectOneEntry: '请选择一条数据！',
  PleaseOnlySelectOneRecord: '请只选择一条记录！',
  ContainsAlreadyRemovedData: '包含已经下架数据！',
  AreYouWantToRemove: '确定要下架吗?',
  AreYouWantToPublish: '确定要发布吗吗?',
  ThePositionHasBeenDisabled: '该广告位已停用！',
  TheReachedTheMaximumPlacements: '该广告位已达最大投放数量！',
  RemainingAreNotEnoughCheck: '剩余可投放广告位不足，请检查！',
  ContainsPublishedOrExpiredData: '包含已经发布或失效数据！',
  View: '查看',
  Edit: '编辑',
  Enable: '启用',
  Disable: '停用',
  AdPositionNumber: '广告位编号',
  CurrentlyPlacedAdCount: '已投放广告数',
  MaximumSupportedAdCount: '支持最大广告数',
  CurrentDisabledAndCannotEdited: '当前数据未停用，不可编辑！',
  AreYouWantToDisable: '确定要停用吗?',
  AreYouWantToDisable2: '确定要禁用吗?',
  ContainsNonDisabledData: '包含非停用数据！',
  AreYouWantToEnable: '确定要启用吗?',
  TemplateManagement: '模板管理',
  TemplateTypeManagement: '模板类型管理',
  ConfigurationManagement: '配置管理',
  MappingManagement: '映射管理',
  InitializeTemplateManagement: '初始化模板管理',
  BusinessStatusManagement: '业务状态管理',
  TriggerTypeManagement: '触发类型管理',
  FileTypeManagement: '文件类型管理',
  DefaultValueManagement: '默认值管理',
  ValidationRuleConfiguration: '验证规则配置',
  EDITemplateSetting: 'EDI模板设置',
  SeaFreightOnlineCheckingSettings: '海运在线对单设置',
  ShippingRouteAndWarehouseConfiguration: '航线与仓库配置',
  PushServiceConfiguration: '推送服务配置',
  InvoiceCustomRemark: '发票自定义备注',
  CustomRemarkOne: '自定义备注1',
  CustomRemarkTwo: '自定义备注2',
  EmailTemplateManagement: '邮箱模板管理',
  ReleaseConfiguration: '放单配置',
  PromotionTimeRange: '推广时间段',
  JumpLink: '跳转链接',
  Cancel: '取消',
  Save: '保存',
  Return: '返回',
  Homepage: '首页',
  SelectAll: '全部选中',
  DeselectAll: '全部取消选中',
  AreYouWantToCancel: '确认取消吗？',
  NumberOfClickedUsers: '点击用户数',
  BelongToCompany: '所属公司',
  UserType: '用户类型',
  Username: '用户名',
  PlatformCustomerService: '平台客服',
  ClickTime: '点击时间',
  BrowsingTime: '浏览时间',
  StartTime: '开始时间：',
  EndTime: '结束时间：',
  SequenceNumber: '顺序号',
  Code: '代码',
  ChineseName: '中文名字',
  EnglishName: '英文名字',
  NodeType: '节点类型',
  Remarks: '备注',
  CreateStatus: '新建状态',
  Delete: '删除',
  IsItPublic: '是否公开',
  CreateStatusDetail: '新建状态明细',
  EditStatus: '编辑状态',
  DeleteSuccessful: '删除成功',
  SaveSuccessful: '保存成功',
  PleaseEnterCode: '请输入code',
  PleaseEnterNodeType: '请输入节点类型',
  PleaseEnterCodeChineseName: '请输入code中文名',
  PleaseEnterCodeEnglishName: '请输入code英文名',
  StatusType: '状态类型',
  ExternalCode: '外部编码',
  Name: '名称',
  GenerateElectronicFile: '生成电子文件',
  FileType: '文件类型',
  DataService: '数据服务',
  ReportTemplate: '报表模板',
  PushObject: '推送对象',
  PushChannel: '推送渠道',
  SubjectTemplate: '主题模板',
  BodyTemplate: '正文模板',
  DataItem: '数据项',
  AttachmentFileType: '附件文件类型',
  TemplateSubject: '模板主题',
  TemplateContent: '模板内容',
  TemplateExample: '模板示例',
  SendTest: '发送测试',
  ConfigureSOPMessagePush: '配置SOP消息推送',
  EditStatusDetail: '编辑状态明细',
  InitialStatus: '初始状态',
  AutoTrigger: '自动触发',
  StatusChangeNotification: '状态变更通知',
  SendNotification: '发送通知',
  NoNotification: '不发送通知',
  DesignatedPosition: '指定岗位',
  Sales: '销售',
  Operation: '操作',
  CustomerService: '客服',
  OverseasCustomerService: '海外客服',
  Documentation: '单证',
  ShippingLineManager: '航线负责人',
  DesignatedPersonnel: '指定人员',
  Email: '邮件',
  SopPushLog: 'sop推送日志',
  Confirm: '确认',
  SendTo: '发送至：',
  Note: '注意',
  WillBusinessDetailsAndNodes: '将会删除所关联的业务明细和sop节点',
  PleaseEnterContent: '请输入内容',
  NotStarted: '未开始',
  InProgress: '进行中',
  Completed: '已完成',
  Abnormal: '异常',
  BookingSuccessful: '订舱成功',
  WarehouseEntryNotice: '入仓通知',
  CustomsClearance: '报关放行',
  SailingNotice: '开航通知',
  IssuanceOfBillOfLading: '签发提单',
  Customer: '客户',
  DestinationPortAgent: '目的港代理',
  DesignatedFreightForwarder: '指定货代理',
  DeparturePortAgent: '起运港代理',
  DesignatedPositionsAndPersonnel: '指定岗位和指定人员',
  PleaseEnterTheCode: '请输入代码',
  PleaseEnterTheChineseName: '请输入中文名',
  ChineseNameLengthExceeded20: '中文名长度超过20!',
  PleaseEnterTheEnglishName: '请输入英文名',
  PleaseSelectTheStatusType: '请选择状态类型!',
  PleaseSelectTheTriggerType: '请选择触发类型',
  PleaseSelectTheStatusType2: '请选择状态类型',
  TheAlreadyExistsPleaseEnter: '已经存在相同的代码,请重新输入!',
  TheAlreadyExistsPleaseEnter2: '已经存在相同的中文名,请重新输入!',
  TheAlreadyExistsPleaseEnter3: '已经存在相同的英文名,请重新输入!',
  SaveSuccess: '保存成功',
  DeleteSuccess: '删除成功',
  BusinessDetailsDoNotExist: '业务详情不存在',
  PleaseEnterTheSubjectTemplate: '请输入主题模板',
  PleaseTheTextTemplateContent: '请输入正文模板内容',
  PleaseEnterTheTemplateContent: '请输入模板内容',
  PleaseEnterTheTemplateExample: '请输入模板示例',
  PleaseFirstSelectData: '请先选择数据',
  AreWantToDeleteRecord: '确定删除选择的记录吗?',
  Tips: '提示',
  PleaseTheTestEmailAddress: '请输入测试邮箱地址!',
  EmailFormatError: 'Email格式错误!',
  EmailCannotExceed128Characters: 'Email长度不能超过128个字符',
  PleaseTestMobilePhoneNumber: '请输入测试手机号!',
  MobileCanOnlyBeNumbers: '手机号码只能为有效数字!',
  MobilePhoneNumberFormatError: '手机号码格式错误!',
  SendSuccess: '发送成功！',
  SendFailure: '发送失败！',
  APIOutputAdditionalInformation: 'API输出附加信息',
  OutputDescription: '输出说明',
  OutputIdentification: '输出标识',
  DataSource: '数据来源',
  DataField: '数据字段',
  WarningSwitch: '预警开关',
  SailingTimeETD: '开航时间（ETD）',
  ArrivalTimeETA: '到港时间（ETA）',
  OpenPortTime: '开港时间',
  ClosingPortTime: '截港时间',
  ClosingTimeForOrders: '截单时间',
  CustomsClosingTime: '截关时间',
  ScheduledBerthingDate: '计划靠泊日期',
  ScheduledDepartureDate: '计划离泊日期',
  WarningTime: '预警时间',
  Advance: '提前',
  Delay: '延后',
  WarningSettings: '预警设置',
  TurnOnWarning: '开启预警',
  TurnOffWarning: '关闭预警',
  HoursWarningReminder: '小时，预警提醒',
  Highest: '最高',
  High: '高',
  Medium: '中',
  Low: '低',
  Relation: '关系',
  FilterValue: '过滤值',
  ValidationCondition: '验证条件',
  New: '新建',
  And: '与',
  Or: '或',
  FilterBasis: '过滤依据',
  CurrentlyModeUnableToNew: '当前处于编辑状态，不可新建',
  CurrentlyModeUnableToDelete: '当前处于编辑状态，不可删除',
  PleaseSelectAFilterBasis: '请选择过滤依据',
  PleaseSelectTheFilterValue: '请选择过滤值',
  ValidationExpression: '验证表达式',
  PositiveOperation: '正操作',
  PreSubmit: '预提交',
  Submitted: '已提交',
  Reviewed: '已审核',
  ValidationItem: '验证项目',
  Empty: '空',
  PleaseSelectValidationItem: '请选择验证项目',
  RuleName: '规则名称',
  ValidationNode: '验证节点',
  ValidationType: '验证类型',
  ValidationMode: '验证模式',
  EmailAddress: '邮件地址',
  Add: '新增',
  Refresh: '刷新',
  ValidationRules: '验证规则',
  AllowOperationAfterValidationFails: '验证不通过后是否允许继续操作?',
  Yes: '是',
  No: '否',
  Company: '公司',
  ContinueValidation: '继续验证',
  CurrentlyYouSureYouRefresh: '当前正处于编辑状态，确定刷新吗?',
  FailedToInitializeData: '初始化数据失败',
  AreRuleAssociatedValidationDeleted: '确认要删除这条验证规则吗?所关联验证表达式和验证条件也将被删除!',
  PleaseSelectTheBranchOffice: '请选择分公司',
  PleaseEnterTheRuleName: '请输入规则名称',
  PleaseSelectTheRuleNode: '请选择规则节点',
  PleaseSelectTheRuleType: '请选择规则类型',
  PleaseSelectTheRuleMode: '请选择规则模式',
  CompanyName: '公司名称',
  PleaseConfigurationNameOrRemarks: '请输入配置名或备注',
  Type: '类型',
  InterfaceSettings: '界面设置',
  ConfigurationName: '配置名',
  DefaultValue: '缺省值',
  EditConfigurationItem: '编辑配置项',
  EditConfigurationDefinition: '编辑配置定义:',
  Search: '检索',
  ConfigurationItemconfigId: '配置项(configId)',
  TypedataType: '类型(dataType)',
  InterfaceSettingsisClient: '界面设置(isClient)',
  BranchOfficeOptionisOfficeOption: '分公司选项(isOfficeOption)',
  ServiceSettingsisServer: '服务设置(isServer)',
  OptionalItemliterals: '可选项(literals)',
  ConfigurationNamename: '配置名(name)',
  Remarksremarks: '备注(remarks)',
  DefaultValuevalue: '缺省值(value)',
  ConfigurationNameCannotBeEmpty: '配置名不能为空',
  DefaultValueCannotBeEmpty: '缺省值不能为空',
  PleaseEnterTheBranchOffice: '请输入分公司',
  Value: '值',
  ConfigurationItem: '配置项',
  BranchOffice: '分公司',
  PleaseSelectAConfigurationDefinition: '请选择一项配置定义',
  BranchOfficeCannotBeEmpty: '分公司不能为空!',
  ValueCannotBeEmpty: '值不能为空!',
  TheConfigurationAlreadyExistsCheck: '已存在相同分公司配置，请检查',
  ApplyHeadOfficeSettings: '应用总公司设置',
  SleepingDays: '沉睡天数',
  SigningDays: '签单天数',
  NotificationObject: '通知对象:',
  Supervisor: '上级主管',
  NotificationMethod: '通知方式:',
  InternalReminder: '内部提醒',
  HowDaysBeforeExpirationNotice: '到期前多少天通知:',
  Days: '天',
  DayMaintenance: '天数维护:',
  BusinessEntity: '业务实体',
  SelectEntityConfigurationItem: '选择实体配置项',
  BranchOffice2: '分公司：',
  EntitySelection: '实体选择：',
  AffiliatedBranchOffice: '所属分公司',
  EntityCode: '实体代码',
  EntityName: '实体名称',
  FieldCode: '字段代码',
  FieldName: '字段名称',
  ValueType: '值类型',
  All: '全部',
  SelectBranch: '选择分公司',
  Unused: '未使用',
  Used: '已使用',
  Example8180ThisTicketOnlyDollars: '例: USD:355/汇率:6.8180/此票只收美金',
  Precautions: '注意事项：',
  SavedEffectFromTheInvoice: '保存配置后从下一张发票开始生效',
  EBeLessThanCharacters: '电票备注须小于100个字',
  PaperBeLessThanCharacters: '纸票备注须小于200个字',
  AutomaticallyALineDoesShow: '一行显示不下时会自动换行',
  PDFCanDisplayUpLines: 'PDF格式发票备注栏最多显示三行',
  SerialNumber: '顺序号',
  ExternalFileType: '外部文件类型',
  NecessaryScenario: '必要场景',
  OriginalScenario: '正本场景',
  TypePermission: '类型权限',
  AllPositions: '所有岗位',
  Client: '委托单位',
  Shipper: '发货人',
  Consignee: '收货人',
  OverseasAgent: '海外代理',
  BookingAgent: '订舱代理',
  PleaseSelectBookingAgent: '请选择订舱代理',
  ExternalAccess: '外部访问',
  B2BCustomer: 'B2B客户',
  B2BDesignatedCargoAgent: 'B2B指定货代理',
  B2BDestinationPortAgent: 'B2B目的港代理',
  B2BConsignee: 'B2B收货人',
  TemplateOutputName: '模板输出名称',
  Delimiter: '分隔符',
  NoteTemplateNameAccordingNeeds: '注:请根据自己需要定义导出模板名称',
  DefaultSync: '默认同步',
  UsedFileAutomaticallySynchronizesBusiness: '用于设置该类型文件是否自动在出口和进口业务中互相同步',
  CustomTemplateName: '自定义模板名称',
  TemplateName: '模板名称',
  Underscore_: '下划线_',
  Hyphen: '中划线-',
  CreateFileClassification: '新建文件归类',
  CreateFileType: '新建文件类型',
  Create: '新建',
  Modify: '修改',
  FileClassification: '文件归类',
  CurrentOperationStatusIsAbnormal: '当前操作状态异常！',
  PleaseSelectChineseName: '请选择中文名称',
  CurrentOperatingStatusAbnormal: '当前操作状态异常',
  CondAlreadyExists: 'cond已经存在',
  EDIFileDefaultTypeDefaultFileType: 'EDI文件默认类型(DefaultFileType)',
  Emailemail: '邮箱(email)',
  EDIFileEncodingTypeEncodingType: 'EDI文件编码类型(EncodingType)',
  EDIFileCombinationMethodFileCombineType: 'EDI文件合并方式(FileCombineType)',
  PartnerCodeParnterId: '合作伙伴代码(ParnterId)',
  SendFTPFileNamePrefixsendFilePrefix: '发送FTP文件名前缀(sendFilePrefix)',
  SendFTPAddressTypesendType: '发送FTP地址类型(sendType)',
  ServiceTypeServiceType: '服务类型(ServiceType)',
  TemplateDescriptionTemplateDescribe: '模板说明(TemplateDescribe)',
  TemplateAccessPathTemplatePath: '模板访问路径(TemplatePath)',
  TemplateTypeTemplateType: '模板类型(TemplateType)',
  ShutNoticeShutOutIdentification: '退关报文(Shut-out identification)',
  BootHelperPage: '引导辅助页(Boot helper page)',
  EDITemplateMaintenance: 'EDI模板维护',
  PleaseEDIFileCombinationMethod: '请输入EDI文件合并方式',
  EDIMethodMustBeType: 'EDI文件合并方式必须为数字类型',
  PleaseEnterPartnerCode: '请输入合作伙伴代码',
  PartnerMustBeNumericType: '合作伙伴代码必须为数字类型',
  PleaseEnterServiceType: '请输入服务类型',
  ServiceMustBeNumericType: '服务类型必须为数字类型',
  PleaseEnterTemplateDescription: '请输入模板说明',
  PleaseEnterTemplateAccessPath: '请输入模板访问路径',
  PleaseEnterTemplateType: '请输入模板类型',
  TemplateMustBeNumericType: '模板类型必须为数字类型',
  ShutMustBeNumericType: '退关报文必须为数字类型',
  CloudStorageID: '云存储ID',
  TemplateFileCloudStorage: '模板文件云存储',
  PleaseTemplateYouWantEdit: '请选择需要编辑的模板！',
  PleaseTemplateYouWantDelete: '请选择需要删除的模板！',
  ConfirmDeletionOfThisTemplate: '确认要删除该模板吗？',
  TemplateDeletedSuccessfully: '模板删除成功！',
  TemplateDeletionFailed: '模板删除失败！',
  BasicFailedPleaseTryAgain: '基础模板更新失败，请重新尝试！',
  BasicTemplateUpdateSuccessful: '基础模板更新成功！',
  PleaseEnterKeywordsToSearch: '请输入关键字搜索',
  EmailTemplateEditing: '邮箱模板编辑',
  PushingLink: '推送环节',
  TextTemplate: '正文模板',
  Reminder: '提示',
  SendEmail: '发送邮箱：',
  OK: '确定',
  BasicData: '基础数据',
  SystemEmail: '系统邮箱',
  PicturePictureMustNot10M: '图片上传失败,图片最大不能超过10M!',
  PleaseAddProductDescriptionHere: '请在这里添加产品描述',
  PreSendingSupplementaryInvitationLink: '预配信息发送补充邀请链接',
  MarineMBLInvitationForProofreading: '海运出口MBL邀请对单',
  MarineHBLInvitationForProofreading: '海运出口HBL邀请对单',
  MarineExportBulkPrinting: '海运出口批量打印',
  AirCargoStorage: '空运仓储',
  BillOfLadingPrintProduction: '提单制作打印',
  FileHistory: '文件历史',
  InvoicePush: '发票推送',
  OceanShippingAlertReminderEmail: '海运-预警提醒邮件',
  ReminderEmail: '提醒邮件',
  AirExportAlertReminderEmail: '空运出口-预警提醒邮件',
  RailwayAlertReminderEmail: '铁路-预警提醒邮件',
  AirImportAlertReminderEmails: '空运进口-预警提醒邮件',
  IntegratedAlertReminderEmails: '综合物流-预警提醒邮件',
  BookingPageData: '订舱页数据',
  ContentTemplate: '内容模板',
  Updater: '更新人',
  LastUpdateTime: '最后更新时间',
  UploadedBeLargerThan20MB: '上传图片不能大于20MB',
  PictureInsertionFailed: '图片插入失败',
  OnlyVieweditOneEmailTemplate: '只允许查看/编辑一条邮件模板',
  CompanyEmail: '公司邮箱',
  PersonalEmail: '个人邮箱',
  SentSuccessfully: '发送成功！',
  ConfirmTheModifiedContent: '是否确认修改后的内容？',
  ConfirmCancelingTheFilledmodifiedContent: '是否确认取消已填写/修改内容？',
  PleaseInTheRecipientsEmail: '请填写收件邮箱！',
  MappingType: '映射类型',
  Description: '描述',
  Condition: '条件',
  SendingPlatform: '发送平台',
  EnglishName2: '英文名称',
  ChineseName2: '中文名称',
  OriginalValue: '原值',
  NewValue: '新值',
  EditMapping: '编辑映射',
  CreateMapping: '新建映射',
  PleaseEnterMappingType: '请输入映射类型',
  PleaseEnterTheOriginalValue: '请输入原值',
  PleaseEnterTheNewValue: '请输入新值',
  Branch: '分公司',
  EnableAutomaticPush: '开启自动推送',
  SOPPushChannel: 'SOP推送渠道:',
  PushOnlyAfterConfirmingRecipient: '确认SOP接收人后才推送SOP状态:',
  PleaseSendersEmailWhichEmails: '请勾选以下邮箱作为发件邮箱，并在发送邮件时可使用。',
  Username2: '用户名:',
  EmailPasswordauthorizationCode: '邮箱密码/授权码:',
  EmailDisplayName: '邮件显示名称:',
  SenderServer: '发件服务器:',
  Port: '端口:',
  WhenActualSenderIsEmail: '选择个人邮箱时，实际发件人为每个用户的注册邮箱。',
  CompanyEnglishAbbreviation: '公司英文简称:',
  BasicConfiguration: '基本配置',
  SMS: '短信',
  Open: '开启',
  Close: '关闭',
  EmailConfiguration: '邮箱配置',
  Signature: '签名：',
  EnableSignature: '启用签名',
  SMSConfiguration: '短信配置',
  PleaseAProductDescriptionHere: '请在这里添加产品描述',
  CompanyAbbreviationCannotBeEmpty: '公司中文简称不能为空！',
  CompanyUsernameCannotBeEmpty: '公司邮箱用户名不能为空！',
  CompanyCodeCannotBeEmpty: '公司邮箱邮箱密码/授权码：不能为空！',
  CompanyServerCannotBeEmpty: '公司邮箱发件服务器不能为空！',
  CompanyNumberMustBeNumber: '公司邮箱端口号必须为数字！',
  PersonalUsernameCannotBeEmpty: '个人邮箱用户名不能为空！',
  PersonalServerCannotBeEmpty: '个人邮箱发件服务器不能为空！',
  PersonalNumberMustBeNumber: '个人邮箱端口号必须为数字！',
  AdditionalOutputAssociatedTemplate: '附加输出关联模板',
  TemplateEngine: '模板引擎',
  FilterScript: '过滤脚本',
  BranchSerialNumber: '分公司序号',
  TemplateFile: '模板文件',
  TemplateClass: '模板类',
  TemplateUsage: '模板用途',
  Print: '打印',
  CreateTemplate: '创建模板',
  TemplateFileCloudStorageID: '模板文件云存储ID',
  TemplateSerialNumber: '模板序号',
  SchemaTypeNotMaintained: 'SchemaType未维护',
  CannotCheckWhetherTheCorrect: '未查询到基础模板信息,请检查模板数据源是否正确！',
  SchemaTypeCannotBeEmpty: 'Schema Type不能为空.',
  TemplateTypeCannotBeEmpty: 'Template Type不能为空',
  TemplateDescCannotBeEmpty: 'Template Type Desc不能为空',
  ChineseNameLengthExceeds20: '中文名长度超过20!',
  PleaseSelectStatusType: '请选择状态类型!',
  PleaseSelectATriggerType: '请选择触发类型',
  DropThisConditionForGoods: '*下拉选择框为空表示不考虑该条件。如：不考虑货物类型',
  PushTarget: '推送对象',
  BookingSuccess: '订舱成功',
  WarehouseEntryNotification: '入仓通知',
  BillOfLadingIssuance: '签发提单',
  DesignatedFreightAgent: '指定货代理',
  DesignatedPostAndDesignatedPersonnel: '指定岗位和指定人员',
  PleaseSelectDataFirst: '请先选择数据',
  AreToDeleteTheRecord: '确定删除选择的记录吗?',
  Hint: '提示',
  PleaseEnterTestEmailAddress: '请输入测试邮箱地址!',
  PleaseEnterTestMobileNumber: '请输入测试手机号!',
  MobileOnlyBeANumber: '手机号码只能为有效数字!',
  MobileNumberFormatError: '手机号码格式错误!',
  SendingSuccessful: '发送成功！',
  SendingFailed: '发送失败！',
  ChineseName3: '中文名',
  EnglishName3: '英文名',
  PublicOrNot: '是否公开',
  Remark: '备注',
  AutomaticTrigger: '自动触发',
  DoNotSendNotification: '不发送通知',
  DesignatedPost: '指定岗位',
  Documentary: '单证',
  LineManager: '航线负责人',
  PleaseEnterChineseName: '请输入中文名',
  PleaseEnterEnglishName: '请输入英文名',
  PleaseSelectTriggerType: '请选择触发类型',
  PleaseSelectStatusType2: '请选择状态类型',
  ThereSameCodePleaseEnter: '已经存在相同的代码,请重新输入!',
  ThereSameChineseNameEnter: '已经存在相同的中文名,请重新输入!',
  ThereSameEnglishNameEnter: '已经存在相同的英文名,请重新输入!',
  PleaseEnterFieldName: '请输入字段名称',
  PleaseEnterFieldEnglishName: '请输入字段英文名称',
  AreToDeleteTheType: '确认要删除触发类型吗?',
  AllCharts: '全部图表',
  BusinessCharts: '业务图表',
  FinancialCharts: '财务图表',
  ControlMode: '控制模式:',
  ReceivingOrder: '接单',
  Printing: '打印',
  BillOfLadingRelease: '提单放单',
  NoDeduction: '不扣单',
  OnlyHBL: '只有HBL',
  OnlyHBLDeductHBL: '只有HBL扣HBL',
  OnlyMBL: '只有MBL',
  OnlyMBLDeductMBL: '只有MBL扣MBL',
  HBLAtTheSameTime: 'HBL & MBL同时有',
  HBLAtTheSameTime2: 'HBL、MBL同时扣',
  OnlyHBLWithoutDeductingMBL: '只扣HBL不扣MBL',
  DoHBLOnlyDeductMBL: '不扣HBL只扣MBL',
  DocumentCirculation: '单证流转',
  ApplyTheHeadOfficesSettings: '应用总公司设置',
  ReminderMode: '提醒模式',
  LockingMode: '锁单模式',
  WhenRemindersAndTheLocked: '信控超出后,只发送提醒,工作单不会锁定',
  WhenOrderUntilItApproved: '信控超出后,锁定工作单，直至自动解锁或人工特批',
  NotificationReminder: '通知提醒:',
  LockingControl: '锁定控制:',
  Event: '事件',
  IsLocked: '是否锁定',
  ControlObject: '控制对象',
  ControlMethod: '控制方式',
  PrintTemplate: '打印模板',
  Document: '单证',
  EmailAndReminder: '邮件和提醒',
  None: '无',
  SaveAndLock: '保存后锁定',
  CannotSave: '不可保存',
  BusinessLocked: '业务被锁定',
  BusinessUnlocked: '业务被解锁',
  CreditControlExceed: '信控超出',
  CreditControlChange: '信控更改',
  AddCopyFormalBusiness: '新增/复制正式业务',
  OperationSupervisor: '操作主管',
  SalesSupervisor: '销售主管',
  CreditControlSupervisor: '信控主管',
  BusinessCustomerService: '业务客服',
  MBLTabPrint: 'MBL页签打印',
  MBLSplitMergePrint: 'MBL拆单/并单打印',
  HBLOriginalPrint: 'HBL正本打印',
  HBLSplitMergeOriginalPrint: 'HBL拆单/并单正本打印',
  HBLTelexPrint: 'HBL电放打印',
  HBLSplitMergeTelexPrint: 'HBL拆单/并单电放打印',
  BookingTabPrint: '订舱页签打印',
  BasicTab: '基本页签',
  MAWBTab: 'MAWB页签',
  HAWBTab: 'HAWB页签',
  BookingEDI: '订舱EDI',
  BillOfLadingEDI: '提单EDI',
  ReturnOrder: '退单',
  AbnormalStatus: '异常状态',
  User: '用户',
  IPAddress: 'IP地址',
  PleaseEnterTheIPAddress: '请输入ip地址.',
  IndicatesUnrestricted: '表示不受限制',
  IPAddressCannotBeEmpty: 'ip地址不能为空',
  PleaseSelectAUser: '请选择用户',
  ThisAlreadyAddedAnWhitelist: '该用户已添加IP白名单',
  ExistingSameIPAddress: '已存在相同的ip地址',
  PleaseSelectData: '请选择数据',
  BusinessType: '业务类型',
  BillOfLadingType: '提单类型',
  DesignatedShippingLine: '指定船司',
  Expression: '表达式',
  Example: '示例',
  LetterSuffix: '字母后缀',
  LetterexcludingIAndO: '字母后缀(不含I和O)',
  NumberSuffix: '数字后缀',
  MasterBillExtension: '主单号顺延',
  SuffixSeparator: '后缀分隔符',
  Constant: '常量',
  AddRule: '添加规则',
  PleaseEnterRuleName: '请输入规则名称',
  Reset: '重置',
  ServiceCodeMaintenance: '服务码维护',
  BusinessTypelob: '业务类型(lob)',
  CargoPickupType: '揽货类型',
  BranchCodeoffice: '分公司代码(office)',
  Salesperson: '业务员',
  NetCodenetCode: '网管代码(netCode)',
  SalesDepartment: '销售部门',
  OperationsDepartment: '操作部门',
  OverseasWarehouseCodeFBAFC: '海外仓编码(FBA FC)',
  PortCodeport: '港口代码(port)',
  DeliveryPlaceCodeport: '交货地代码(port)',
  PolCode: '起运港代码(POL)',
  DeparturePortCode: '起运港代码',
  DestinationPortCode: '目的港代码',
  DeparturePortExchangeCode: '起运港交换码',
  DestinationPortExchangeCode: '目的港交换码',
  ServiceCode: '服务码',
  OverseasAgentCode: '海外代理代码',
  JobNumberjobNo: '工作单号(jobNo)',
  ReceivableOrPayable: '应收应付(RP)',
  Jobyear: 'job(年)',
  Yearyear: '年份(year)',
  Length: '长度',
  Jobmonth: 'job(月)',
  Monthmonth: '月份(month)',
  Dateday: '日期(day)',
  JobSequenceNumberjobSequence: 'Job序列号(jobSequence)',
  RandomLetters: '字母随机',
  SequenceNumbersequence: '序列号(sequence)',
  CustomBusinessTypecustomJobType: '自定义业务类型(customJobType)',
  SequenceNumberSettings: '序列号设置',
  NeverResetN: '永不重置(N)',
  ResetByYearY: '按年重置(Y)',
  ResetByMonthM: '按月重置(M)',
  ResetByDayD: '按日重置(D)',
  BusinessDate: '业务日期',
  DepartureDate: '开航日期',
  ShippingDate: '发运日期',
  ArrivalDate: '到港日期',
  BranchSequenceNumberIndependent: '分公司序列号独立',
  CustomJobTypeSequenceNumberIndependent: '自定义业务类型序列号独立',
  PaymentDirectionSerialNo: '收付方向序列号独立',
  DomesticBill: '国内账单',
  DomesticBillNo: '国内账单号',
  ReceivableAndPayableio: '应收应付(io)',
  BranchConfigurationIndependent: '分公司配置独立生效',
  JoiningDeclarationNumberRule: '加拼关单号规则',
  TakeBillDateOnYearMonthDay: '年月日取账单日期',
  TakeDocumentDateOnYearMonthDay: '年月日取制单日期',
  TakeActualPayDateOnYearMonthDay: '年月日取实际收付日期',
  UseBillDateOnYearMonthDay: '使用对账单账单日期作为年份、月份、日期流水号控制。',
  UseDocumentDateOnYearMonthDay: '使用对账单制单日期作为年份、月份、日期流水号控制。',
  UseActualPayDateOnYearMonthDay: '使用实际收付作为年份、月份、日期流水号控制。',
  DomesticStatement: '国内对账单',
  ForeignStatement: '国外对账单',
  AddConstant: '添加常量',
  PleaseToJobNumberSettings: '请参看工作单号设置',
  ConstantCannotBeEmpty: '常量不能为空',
  ConstantSpecialCharacters$: '常量中不能包含特殊字符$、{、}',
  ConfigurationCannotBeEmpty: '配置不能为空!',
  LengthExceedsAllowableLength: '长度超过允许长度!',
  ConfigurationExpressionCannotBeEmpty: '配置表达式不能为空',
  ThereAtLeastOneName: '至少要有一条规则名称',
  JoiningMustChooseAtItem: '加拼关单号规则最少要选择一项',
  ChangingInTheSystemModification: '改动配置可能会影响系统中历史数据的查询，是否保存修改？',
  RuleNameAlreadyExists: '规则名称已存在',
  SaveFailed: '保存失败',
  AreWantToDeleteRule: '是否确定删除此规则?',
  Prompt: '提示',
  BranchBankAccount: '分公司银行账号',
  SetAsDefaultRMBAccount: '设为默认RMB账号',
  SetAsDefaultUSDAccount: '设为默认USD账号',
  Currency: '币种',
  Bank: '开户银行',
  Abbreviation: '简称',
  AccountNumber: '账号',
  RMBDefaultAccount: 'RMB默认账号',
  USDDefaultAccount: 'USD默认账号',
  BankChineseAddress: '银行中文地址',
  BankEnglishAddress: '银行英文地址',
  TheItCannotBeAccount: '该帐号的币种不是RMB，不能被选为默认RMB帐号。',
  TheItCannotBeAccount2: '该帐号的币种不是USD，不能被选为默认USD帐号。',
  NameDoYouWantSave: ']名称已存在是否保存？',
  SaveWantToCloseWindow: '保存成功,是否要关闭窗口?',
  CurrencyCannotBeEmpty: '币种不能为空',
  CodeCannotBeEmpty: '代码不能为空',
  EnglishNameCannotBeEmpty: '英文名不能为空',
  AccountNumberCannotBeEmpty: '账号不能为空',
  TaxControlDiskNumberMaintenance: '税控盘编号维护',
  Number: '编号',
  InvoiceCode: '开票点代码',
  UsageDepartment: '使用部门',
  TheNumberCannotBeRepeated: '编号不能重复！',
  InvoiceCodeCannotBeRepeated: '开票点代码不能重复！',
  OneToMaintainMultipleNumbers: '一个部门不允许维护多个税控盘编号',
  NumberCannotBeEmpty: '编号不能为空！',
  InvoiceCodeCannotBeEmpty: '开票点代码不能为空！',
  UsageDepartmentCannotBeEmpty: '使用部门不能为空!',
  DepartmentCode: '部门代码',
  JobNumberEncodingField: '工作号编码字段',
  IsItASettlementCompany: '是否为结算公司',
  AddDepartment: '添加部门',
  TheOfTheDepartmentEmpty: '部门的中文名或英文不能为空',
  EnabledSuccessfully: '启用成功!',
  DisabledSuccessfully: '禁用成功!',
  SaveSuccessfully: '保存成功!',
  CompanyCode: '公司代码',
  BranchChineseName: '分公司中文名',
  ChineseAddress: '中文地址',
  BranchEnglishName: '分公司英文名',
  City: '城市',
  PostalCode: '邮政编码',
  Fax: '传真',
  Phone: '电话',
  LocalCurrency: '当地币种',
  DefaultAirport: '默认空港',
  DefaultSeaport: '默认海港',
  SeaBillOfLadingAddress: '海运提单地址',
  AirBillOfLadingAddress: '空运提单地址',
  RMBAccount: '人民币账号',
  USDAccount: '美元账号',
  OverseasBillAddress: '海外账单地址',
  DomesticBillAddress: '国内账单地址',
  OverseasEDICode: '海外EDI代码',
  MarkupTaxRate: '加价税率',
  InvoiceTaxRate: '开票税率',
  SettlementEmail: '结算邮箱',
  TaxSystemInterfaceAddress: '税务系统接口地址',
  TaxControlPanelNumber: '税控盘编号',
  InvoiceTitle: '发票抬头',
  InvoiceAddress: '发票地址',
  TaxpayerIdentificationNumber: '纳税人识别号',
  ElectronicTicketPlatformCode: '电票平台编码',
  ElectronicTicketPassword: '电票密码',
  ElectronicTaxpayerIdentificationNumber: '电票纳税人识别号',
  ElectronicTaxpayerAuthorizationCode: '电票纳税人授权码',
  ElectronicTicketServiceRequestAddress: '电票服务请求地址',
  InvoiceCancellationRequestAddress: '发票作废请求地址',
  RelatedPartners: '关联合作伙伴',
  EFreighAMSAccount: 'E-Freigh(AMS账户)',
  EFreighACIAccount: 'E-Freigh(ACI账户)',
  CopyCompany: '复制公司',
  AddBranch: '添加分公司',
  CopyBranch: '复制分公司',
  BankAccount: '银行账号',
  SelectFile: '选择文件',
  RemoveFile: '删除文件',
  NewBranchInformation: '新的分公司信息',
  N1DepartmentsAndPositionBranch: '1、权限管理中该分公司下的所有部门及岗位权限',
  N2ParameterConfiguration: '2、参数配置',
  N3OrderNumberConfiguration: '3、单号配置',
  Preview: '预览',
  Apply: '应用',
  CompanyCodeCannotBeEmpty2: '公司代码不能为空.',
  TheOfTheCompanyEmpty: '公司的中文名或英文不能为空.',
  LocalNotAllowedToEmpty: '当地币种不允许为空.',
  CopyCompanySucceeded: '复制公司成功',
  AreYouSureToDelete: '确定删除吗？',
  DeletedSuccessfully: '删除成功.',
  NameCannotBeEmpty: '名称不能为空',
  SubmitSuccessfully: '提交成功',
  RoleName: '角色名称',
  PleaseSelect: '请选择',
  Individual: '个人',
  DepartmentGroup: '部门分组',
  BatchAddRolePermissions: '批量添加角色权限',
  UpdatePermissionGroup: '更新权限组',
  Removegtgt: '移除&gt;&gt;',
  ltltAdd: '&lt;&lt;添加',
  PermissionName: '权限名',
  PermissionClass: '权限类',
  PermissionType: '权限型',
  PermissionPoint: '权限点',
  Error: '报错了',
  AreDeleteTheCurrentlyRoles: '确定要删除当前选中',
  PleaseOrMoreRolesDelete: '请勾选一个或多个要删除的角色!',
  PleaseOneOrMoreRoles: '请选择一个或多个角色',
  PleaseOneOrMorePermissions: '请选择一个或多个权限',
  BatchAddSuccessfully: '批量添加成功',
  PleaseEnterTheRoleName: '请输入角色名称',
  Meaning: '含义',
  PleaseEnterTheServiceCode: '请输入服务码',
  PleaseTheServiceCodeMeaning: '请输入服务码含义',
  Defaulted: '已默认',
  SetAsDefault: '设为默认',
  SuccessSetting: '设置成功',
  AreToDeleteThisCode: '是否确定删除此服务码',
  SelectCustomer: '选择客户',
  PleaseCodeEnglishNameName: '请输入简称、代码、英文名、中文名',
  PleaseSelectACustomer: '请选择客户.',
  DataCargoTrackingPurchaseEffect: '数据推送服务项目：口岸船舶计划、港区箱货数据、船公司货物追踪。购买数据推送服务此页面配置方可生效',
  PushFCLLCLType: '推送整拼类型',
  PleaseSelectFCLLCLType: '请选择整拼类型',
  DoServicesNeedToVoyage: '口岸船舶计划数据推送服务是否需要更新船名、航次',
  IsTrackingLimitedToDeparture: '船公司货物追踪是否限制起运港',
  EnterpriseType: '企业类型',
  SelectServiceEnabledSelectEffect: '选择全部为全部客户设置开启推送服务的客户；选择白名单为设置开启推送服务的客户；选择黑名单为设置关闭推送服务的客户，仅以最后一次保存时的设置生效。',
  WhiteList: '白名单',
  BlackList: '黑名单',
  DeleteConfiguration: '删除配置',
  PushCondition: '推送条件',
  DataSettings: '数据设置',
  SynchronizationLogicSettings: '同步逻辑设置',
  ClearSettings: '清空设置',
  unBerthPlanDateSynETD: '计划离泊时间同步ETD',
  estimatedArrivalTimeSynETA: '预计到港时间同步ETA',
  ClearVoyageAndShipPeriodData: '清空修改船名航次清空船期数据',
  MorePushConfiguration: '更多推送配置...',
  PortPortOfDepartureRange: '港区数据推送起运港范围',
  Shanghai: '上海',
  Ningbo: '宁波',
  Xiamen: '厦门',
  Shenzhen: '深圳',
  Qingdao: '青岛',
  Tianjin: '天津',
  Fuzhou: '福州',
  Dalian: '大连',
  NanSha: '广州南沙',
  CustomerList: '客户列表',
  CloseOpen: '关闭开通数据服务设置',
  DataServiceSetting: '数据服务设置',
  DataServiceNotUpdateValue: '数据服务不更新该字段值',
  ConditionType: '条件类型',
  Consignor: '委托单位',
  PleaseSelectConsignor: '请选择委托单位',
  SubscriptionScope: '订阅范围',
  NoConfigurationItemsMade: '没有做任何配置项.',
  DeletedSuccessfully2: '删除成功!',
  FCLLCLTypeNotSelected: '整拼类型未选择',
  PleaseSelectWhiteListCustomers: '请选择白名单客户',
  PleaseSelectBlackListCustomers: '请选择黑名单客户',
  SavedSuccessfully: '保存成功！',
  PleaseLeastOneDataDeletion: '请选择至少一条数据进行删除！',
  PushServiceProviderConfiguration: '推送服务商配置',
  PushServiceName: '推送服务名称',
  ServiceProviders: '服务商',
  ShanghaiPort: '上海港口',
  ShippingCompanyCargoTracking: '船公司货物追踪',
  Seabourne: '海勃',
  FreighTower: '飞驼',
  AirCargoTracking: '航货追踪',
  MaritimeDataPush: '海运数据推送',
  AirFreightDataPush: '空运数据推送',
  YundangNet: '云当网',
  SeaButler: '海管家',
  NingboPort: '宁波港口',
  XiamenPort: '厦门港口',
  QingdaoPort: '青岛港口',
  FuzhouPort: '福州港口',
  PortShipSchedule: '口岸船舶计划',
  ShenzhenPort: '深圳港口',
  DalianPort: '大连港口',
  TianjinPort: '天津港口',
  DataPushCustomerList: '数据推送客户列表',
  CustomerWhitelist: '客户白名单:',
  PushContent: '海运推送内容设置',
  AirPushContent: '空运推送内容设置',
  PortContainerData: '港区箱货数据',
  NoCustomerSelected: '未选择客户.',
  UpdateSuccessful: '更新成功',
  Seaport: '海港,',
  Airport: '空港,',
  ChargeItem: '收费项目,',
  Route: '航线,',
  Network: '网络,',
  Currency2: '币种,',
  ContainerType: '箱种,',
  Packaging: '包装,',
  BillOfLadingType2: '提单类型,',
  CargoType: '货物类型,',
  TradeTerms: '贸易条款,',
  TransportTerms: '运输条款,',
  TradeMode: '贸易方式,',
  AirFreightServiceItems: '空运运费服务项目,',
  RelatedPort: '关联港口,',
  AirCargoBillMiscellaneous: '空运运单杂费,',
  CustomerType: '客户类型,',
  BillOfLadingMethod: '提单方式,',
  CustomBusinessType: '自定义业务类型,',
  CirculatingDocumentType: '流转文件类型',
  Initialize: '初始化',
  Success: '成功',
  Failure: '失败',
  AddPort: '添加港口',
  PleaseSelectPort: '请选择港口',
  Operator: '操作人员',
  PleaseSelectPort2: '请选择港口！',
  PleaseSelectOperator: '请选择一个关联用户。',
  TheAlreadyMaintainedThisInformation: '该用户已经维护关联配置',
  PleaseNameEmailEtcQuery: '请输入中文名、英文名、邮箱等模糊查询...',
  NetManagementCode: '网管代码',
  AfterBeAbleToContinue: '设为失效后,该用户就不能登录系统,是否继续?',
  Valid: '有效',
  Invalid: '失效',
  PleaseEnterEmail: '请输入邮箱',
  EditSuccess: '编辑成功',
  EmailDuplicate: '邮箱重复!',
  UserAllowsInputLettersNumbers: '用户代码只允许输入字母和数字.',
  Operator2: '操作人员:',
  PortCode: '港口代码',
  RelatedUser: '关联用户',
  BusinessMode: '业务模式',
  PleaseDataYouWantDelete: '请选择要删除的数据.',
  AreYouWantToDelete2: '确定是否批量删除选中的{0}个配置项吗？',
  DeleteSuccess2: '删除成功.',
  AddRoleUser: '新增角色用户',
  AddUserWithUnassignedRole: '添加未分配角色的用户',
  Query: '查询',
  SelectDepartment: '选择部门',
  AreYouWantToDelete3: '确定要删除吗？',
  SelectedUsersAlreadyExist: '所选的用户已存在',
  AddSuccessfully: '添加成功',
  CopyRole: '复制角色',
  PasteRole: '粘贴角色',
  PleaseRoleYouWantCopy: '请选择要复制的角色!',
  PleaseYouWantToRole: '请选择要粘贴角色所在的部门!',
  IPWhitelist: 'IP白名单',
  UserWhitelist: '用户白名单',
  JobNumber: '工作单号',
  NoteMainAndSplit19: '说明:工作单号最长21位，预留后两位作为主单和拆单标记，因此，在此页配置的单号长度不可以超过19。',
  MainOrderNumber: '主单号',
  NoteNumberIsUpLong: '说明:提单流水号最长16位',
  SubOrderNumber: '分单号',
  NoteIsUpToLong: '说明:分单号最长21位。',
  WarehouseEntryNumber: '进仓编号',
  BookingNumber: '订舱编号',
  NoteYouHaveSelectedLength: '说明:进仓编号最长21位，若选择了工作单号，请注意其实际长度。',
  OverseasBillNumber: '海外账单号',
  NoteIsUpToLong2: '说明:海外账单号最长16位。',
  PaymentApplicationForm: '付款申请单',
  PaymentApprovalForm: '付款审批单',
  NoteIsUpToLong3: '说明:付款申请单号最长16位。',
  NoteIsUpToLong4: '说明:国内账单号最长16位。',
  BillOfLadingSerialNumber: '提单流水号',
  SeaFreightExport: '海运出口',
  SeaFreightImport: '海运进口',
  AirFreightExport: '空运出口',
  AirFreightImport: '空运进口',
  FBASeaFreight: 'FBA海运',
  FBAAirFreight: 'FBA空运',
  ReportName: '报表名',
  Report: '报表',
  PermissionAddedSuccessfully: '权限添加成功',
  PleaseReportLinkedToRole: '请选择角色所关联的报表',
  AreToDeleteTheRole: '确定要删除当前选中的角色吗？',
  PermissionDeletedSuccessfully: '权限删除成功',
  QuickSearchAdTheme: '快捷检索:广告主题',
  AdCode: '广告编号',
  AdThemename: '广告主题/名称',
  AdLocation: '广告位',
  BelongsToPage: '所属页面',
  BelongsToModule: '所属模块',
  BelongingSystem: '所属系统',
  PageViews: '浏览数',
  Clicks: '点击数',
  ClickRate: '点击率',
  NumberOfClickUsers: '点击用户数',
  N0FileTypeNotSelected: '{0}文件类型未选择.',
  NoteCopyFollowingInformation: '注：你选择复制【{0}】包含一下信息:',
  NXRoles: '个的角色吗？',
  BranchSelection: '分公司选择',
  CheckParentCompanyWithSubsidiary: '勾选上级公司附带勾选子公司',
  CurrentlySelectedProject: '当前选中项目：',
  AlertContentConfiguration: '预警内容配置',
  AlertTimeConfiguration: '预警时间配置',
  SopTimeSetUp: 'SOP时间设置',
  SetPersonalEmail: '请设置个人邮箱信息',
  SetPersonalEmailNote1: '设置个人邮箱后，实际发件邮箱为每个用户的个人邮箱，请保证每个用户正确设置个人邮箱。',
  SetPersonalEmailNote2: '如未设置正确，则依次以公司邮箱、系统邮箱作为发件邮箱。',
  SetPersonalEmailStep1: '步骤1：进入设置与工具，个人邮箱设置。',
  SetPersonalEmailStep2: '步骤2：维护个人邮箱密码/授权码、发件服务器、端口及签名信息。',
  SetPersonalEmailStep3: '步骤3：保存后，就可以使用个人邮箱作为发件邮箱使用。',
  WhtTax: 'WHT税模式',
  WhtTaxTip: '泰国等含WHT的场景适用。启用后费用可记录操作及WHT税，销账可扣减WHT税额。',
  SendDestinationPortProxyDocuments: '文件历史-发送目的港代理文件',
  MainTicketAttachmentItem: '主票附件项',
  SmallTicketAttachmentItem: '小票附件项',
  SelectFileType: '选择文件类型',
  IncludeSlaveAttachLabel: '主票发送邮件时，附件需包含小票文件',
  AutoGenerationManifestLabel: '当主票中没有任何MANIFEST文件时，根据箱号自动打印',
  FileAttachmentTip: '如需要发送时对附件进行验证是否存在，请在基本配置-验证规则配置中设置。',
  FileAttachmentTip2: '系统默认根据HBL提单方式自动匹配对应文件附件，可以在基本配置-配置管理中关闭。',
  YearMonthEtdTip: '需同时勾选job(年)job(月)，则按【开航日期】所选的年月进行取值',
  YearMonthEtaTip: '需同时勾选job(年)job(月)，则按【到港日期】所选的年月进行取值',
  RiYearMonthEtaTip: '需同时勾选job(年)job(月)，则按【到达日期】所选的年月进行取值',
  NotifySuperiors: '岗位人员的上级主管',
  NotifySuperiorsCheckTip: '勾选【岗位人员的上级主管】时，必须勾选至少一个【指定岗位】！',
  AddOnlyCurrentTemplate: '仅当前模板添加',
  AddOtherSameLobTempalte: '添加到同业务类型下其他模板中',
  OnlyModifyCurrentTemplate: '仅当前模板修改 ',
  ModifyTemplateContaneNode: '修改所有包含该节点的模板',
  AddRanges: '添加范围',
  ModifyRanges: '修改范围',
  ApplicationTemplate: '应用模板',
  SetNodeLimitTip: '设置节点时，同一业务类型下SOP节点的【代码】【中文名称】【英文名称】需保持一致性。',
  SelectSOPTemplateForNode: '选择节点应用的SOP模板',
  ConfirmJoinSelectTemplate: '确定加入到选中的SOP模板中吗？',
  AddTemplateSameNode: '添加到所有同节点的模板下',
  ModifyTemplateContinNode: '修改所有包含该节点状态的模板',
  HblBlWayAttachLabel: '根据业务的提单方式和提单类型，对应抽取对应的HBL文件',
  HblWithoutGenerateAttachLabel: '无任何HBL文件时，自动打印HBL样张',
  ConfirmedPrintHblLabel: '当HBL状态为已确认，未签发时，自动打印HBL样张',
  PleaseSetSlaveAttach: '请先设置小票附件项文件类型！',
  QueryFileType: '查询文件类型：',
  HblCfmStateOriginDraftLabel: 'HBL状态为未签发时，附件抽取HBL样张，已签发时，附件抽取HBL件',
  BillOfLading: '提单件',
  AssociatedRoutesAndPorts: '关联航线和港口',
  AirlineChineseName: '航线中文名',
  PortEnglishName: '港口英文名',
  OperationPosition: '操作岗位',
  UserConfigDuplicate: '{0}员工已有配置项数据，请勿重复配置。',
  ConfirmSaveModifiedInfo: '确定是否保存修改信息？',
  PleaseSelectARoute: '请选择航线',
  AssociatedPermissions: '关联权限',
  OptionalPositionsRoles: '可选负责岗位限定于用户角色',
  ResponsiblePosition: '负责岗位',
  SelectResponsiblePosition: '请选择负责岗位！',
  ConfigApplyRemoteBooking: '配置应用于远程订舱模块',
  AssociatedWarehouseSupplier: '关联仓库供应商',
  WarehouseNameCustomsBrokeDestinationAgent: '请选择一个关联配置项（仓库名称、报关、目的港代理）',
  RelatedCustomsBroker: '关联报关行',
  RelatedDestinationAgent: '关联目的港代理',
  AssociatedWarehouseName: '关联仓库名称',
  PortCodeRepeat: '{0}港口已有相关设置，请勿重复。',
  RegionCodeRepeat: '{0}航线已有相关设置，请勿重复。',
  DesignatedCargoControlRange: '指定货控制范围：',
  RangeOfSelfPickupControl: '自揽货控制范围：',
  WarningConfiguration: '预警配置：',
  AccountsReceivableSettlementUnits: '所有应收费用结算单位',
  DeletePrompt: '确认删除此账号吗？已经告知云当网此账号废除了吗？',
  EditUser: '编辑用户',
  NewUser: '新增用户',
  Password: '密码',
  CustomerName: '客户名称',
  AccountMaintenance: '调用接口账号维护',
  Unmaintained: '您未提供账号密码无法订阅港区数据，请联系客服。',
  PortNotNull: '港口不能为空',
  CustomerNotNull: '客户名称不能为空',
  AccountNumberNotNull: '账号不能为空',
  PasswordNotNull: '密码不能为空',
  CustomIdNotNull: 'customId不能为空',
  PartnerWarehouseCode: '合作伙伴进仓编号代码',
  PartnerWarehouseCodeTip: '当业务单据中的委托单位，指定货代理，目的港代理都设置进仓编号代时，可设置取值优先级顺序。',
  MailServer: '邮件服务器',
  MailServerConfigTip: '需要先在【推送配置服务】中设置公司邮箱并启用。',
  PushConfigServiceCompanyEmail: '需要先在【推送配置服务】中设置公司邮箱并启用',
  PushConfigServicePersonalEmail: '请选择一个指定岗位或一个指定人的个人邮箱，使用前需要配置个人邮箱并开启使用',
  SelectSendEmail: '选择发送邮箱',
  Assigner: '指定人',
  ConfigEmailForNode: '针对该节点配置发送邮件服务方式',
  MultipleTriggers: '多次触发',
  IsMultipleTriggers: '是否多次触发',
  AllowTriggeringAgainValueChange: '当字段值变动时允许再次触发',
  OnlyEntityCodeSupportTrigger: '仅实体代码为：Job / AirExportJob / AirlmportJob / IntegratedJob /SeaExportJob / Sealmportjob 的日期类型和字符串类型字段支持多次触发，请先和研发确认！',
  TriggerTypeChangePushMsg: '触发类型的值变动再次推送消息',
  CheckBaseLabel: '仅按业务单据的设置的联系人进行推送',
  PushExternalInterfaces: '推送外部接口',
  TriggerInternalEvent: '触发内部事件',
  TriggerTypeChangePushInterface: '触发类型的值变动再次推送接口',
  XhqBillDataUpdate: '信号旗提单数据更新',
  msdBillDataUpdate: '马仕单数据推送接口',
  MsdApiLog: '马仕单接口日志',
  pushPreConfiguredInformation: '推送预配信息',
  pushMasterData: '推送当前主票下所有信息，作为预配数据。核对确认后，请点击"确定”',
  canPushPreConfiguration: '可推送预配',
  AgainPushTitleDisplay: '再次推送的邮件标题中会显示触发类型值的变动情况。显示例如：订舱消息【出口船名航次】原：SITC → 现：LECANGS；原：V.088W → 现：0XSJXS',
  CheckRuleToAllBranch: '验证规则对所有分公司生效',
  CustomDescription: '自定义描述',
  OnlyPositiveFeePermission: '无操作权限。仅可增加正数费用。',
  PleaseSelectOpBranch: '请选择操作分公司！',
  OpOfficeChangeUpdateData: '已修改操作分公司，是否要更新对应的岗位人员？',
  WarehouseChangeUpdateData: '已修改操作分公司，是否要更新对应的仓库/报关行/目的港代理？',
  ClassifyName: '分类名称',
  Sort: '排序',
  ClassifyMsgNameEmpty: '分类名称必填',
  ClassifyMsgSortEmpty: '排序必填',
  ClassifyMsgNameRepeat: '分类名称不可重复',
  ClassifyMsgSortRepeat: '排序号不可以重复',
  ConfirmDeletionOfClassifyMsg: '确定是否删除该消息分类？会同步删除对应的中英日版本！',
  ClassifyMsgDeletedTips: '该消息分类下有消息通知，不可以删除！',
  MsgTitle: '消息标题',
  Content: '正文',
  ConfirmDeletionOfBellMsg: '确定是否删除该消息通知？会同步删除对应的中英日版本！',
  BellMsgTitleEmpty: '消息标题必填',
  BellMsgCodeEmpty: '代码必填',
  BellMsgContentEmpty: '正文必填',
  BellMsgTitleRepeat: '消息标题不可重复',
  BellMsgCodeRepeat: '代码不可重复',
  BellMsgContentRepeat: '正文不可重复',
  Language: '语言',
  Link: '跳转地址',
  LinkTip: '跳转路由用于消息跳转到相应的操作界面，填写前请先和研发确认！',
  BellSubscriptionTitle: '消息订阅设置',
  BellSubscriptionConf: '通知消息订阅',
  BellSubscribed: '已订阅',
  BellUnSubscribed: '未订阅',
  MessageConfig: '消息设置',
  WoBaoIntelligentAssistant: '沃宝智能助手',
  WoBaoSubscriptionTip: '沃宝智能助手会在页面上提醒订阅的今日未读消息',
  AllMessage: '全部消息',
  TodayUnReadMsg: '今日未读消息',
  ViewHQMapping: '查看HQ映射',
  BranchNotMatchNotOperate: '不属于该分公司数据，无法操作',
  UsersAlertNotifyAfterUsingXX: '用户可配置已使用XX%后进行预警通知。',
  UsersAlertNotifyBeforeExpireDate: '用户可配置距离到期日XX天前进行预警通知。',
  UnloadingEortEnName: '卸货港英文名',
  OriginPortEnName: '起运港英文名',
  MatchingCriteriaSelection: '匹配条件选择',
  PresetValueConfiguration: '预设值配置',
  MatchingCriteriaSelectionTip: '用于在业务单据中对应匹配，当符合匹配条件时，进行预设值的自动填写。',
  PresetValueConfigurationTip: '海运出口根据ETD来进行日期提前天数计算。自动补偿双休日天数，天数为0时，表示不自动计算相关日期。',
  PleaseSelectDeparturePort: '请选择起运港',
  PleaseSelectUnloadingPort: '请选择卸货港',
  PleaseSelectCarrier: '请选择承运人',
  PortRequirementBillRequirements: '港口要求（提单要求）',
  PleaseSaveCurrentDataFirst: '请先保存当前数据',
  RelatedInstructionsAttachments: '相关说明附件',
  PortRequirementsRelatedDocuments: '港口要求相关文件',
  NoRelevantDocumentsAvailable: '无相关文件',
  DefaultConfigurationNotes: '预设配置备注',
  PleaseSelectMatchingItem: '请选择一个匹配项',
  CalculateDateIncludeETDTheDay: '提前量计算包含ETD当天',
  SetLeadTimeBasedOnETDTime: '根据ETD时间进行提前量设置',
  PleaseSetPreset: '请设置一个预设项',
  WoBaoSubscribed: '已开启',
  WoBaoUnSubscribed: '已关闭',
  CalculateIncludeEtdIsWeekend: '提前量计算包含ETD是周末',
  PositionAssociatedRoutePortConfig: '岗位人员关联航线/港口预设配置',
  PleaseSelectLoadingPort: '请选择装货港',
  PleaseSelectOriginatingStation: '请选择始发站',
  PleaseSelectDestinationStation: '请选择目的站',
  PositionCannotDuplicated: '岗位不能重复',
  UserHasRepeatConfigData: '该用户已有重复配置数据！',
  UserRoleDefaultRepeat: '已有其他员工配置该匹配条件的岗位默认值，是否确认修改？',
  ChartSource: '图表来源',
  EnterChartSource: '请选择图表来源',
  ToDoNodeRuleSettings: '待办事项节点规则设置',
  ServiceScenarioApplication: '特定业务规则',
  SettingApplicationScenarios: '业务规则设置',
  OperationButtonSettings: '操作按钮设置',
  ButtonName: '按钮名称',
  MainNotToDoTask: '主票单据不作为待办工作任务(拼箱场景)',
  SpecifyRole: '指定角色',
  CheckPrivilegePersonLabel: '是否限制无类型权限的角色修改文件类型',
  SetExclusionOffices: '设置豁免分公司',
  AccountsReceivable: '应收费用',
  Just: '且',
  NotEntityCompany: '非实体公司',
  NotEntityCompanyTip: '特定财务报表统计时，需要勾选此标识。',
  Marked: '打标',
  NotSetDefaultValueMultiPosition: '当条件匹配到多个岗位人员时，不带出默认值，需要手动选择！',
  AvailableOfficeOverMaxLimit: '您的可用分公司数已达上限。如需要增加分公司数量。可以联系您的销售人员或联系客服。',
  AvailableUserOverMaxLimit: '您的可用用户数数已达上限。如需要增加用户数数量。可以联系您的销售人员或联系客服。',
  BranchCountExpireLimitUse: '尊敬的用户，您购买的扩展分公司已过期。<br>请续费后继续使用，可联系您的销售人员或联系客服。<br><div style="margin-top: 5px;">当前分公司将被限制访问，数据将被保留。等续费后，可再次使用。</div>',
  UserCountExpireLimitUse: '尊敬的用户，您购买的扩展用户数已过期。<br>请续费后继续使用，可联系您的销售人员或联系客服。<br><div style="margin-top: 5px;">当前用户将被限制为禁用，数据将被保留。等续费后，可再次激活使用。</div>',
  UserCountExpireLimitAdmin: '尊敬的用户，您购买的扩展用户数已过期。<br>请续费后继续使用，可联系您的销售人员或联系客服。<br><div style="margin-top: 5px;">当前用户（系统管理员除外）将被限制为禁用，数据将被保留。等续费后，可再次激活使用。</div>',
  OpenConfig: '启用配置项',
  SendType: '发送模式',
  Key: '密钥',
  UserPwd: '账户密码',
  OpenConfigTip: '启用后，该模板根据配置的{0}进行发送',
  NotEmptyTips: '蓝色字段为必填字段！',
  MustBeNumericType: '{0}必须为数字类型',
  MainTicket: '主票',
  SlaveTicket: '小票',
  Alias: '别名',
  SetAlias: '设置别名',
  AliasOnlyHQ: '设置别名仅HQ下进行统一设置',
  HideCategoryAllLanguage: '隐藏该分类（应用于所有语言版本）',
  FieldDisplayHideForbid: '当分类下有显示状态的字段时，不允许隐藏！',
  HQSavePrompt: 'HQ保存提示',
  BranchSavePrompt: '分公司保存提示',
  OnlyDisplayMandatoryRule: '仅调整字段的显示和必填规则，不覆盖分公司和员工的自定义页面的字段显示顺序！',
  DisplayMandatorySort: '调整字段的显示和必填规则，并按HQ规则重置分公司和员工的自定义页面的字段显示顺序！',
  AdjustOrderConfig: '该项会使所有的分公司和员工已配置的界面顺序被调整为HQ的设置顺序！',
  OfficeOnlyDisplayMandatoryRule: '仅调整字段的显示和必填规则，不覆盖员工的自定义页面的字段显示顺序！',
  OfficeDisplayMandatorySort: '调整字段的显示和必填规则，并按分公司规则重置员工的自定义页面的字段显示顺序！',
  OfficeAdjustOrderConfig: '该项会使员工已配置的界面顺序被调整为分公司的设置顺序！',
  ApplyHQSetting: '确认是否应用总公司设置？',
  ResetCustomSetConfirm: '是否确认重置该页签的自定义设置？该操作不可逆，请确认！',
  HQSettingNotEditAlias: '应用HQ设置时，分公司不能进行编辑调整。 设置别名在仅HQ下进行统一设置。',
  NonLoginUser: '非登录系统用户',
  ValidUserNotNeedLogin: '有效用户中，无需登陆系统的用户',
  NotLoginUserContactAdmin: '系统管理员已设置您为无需登陆系统用户。如需使用操作系统，请联系您的管理员调整后重新登录。',
  FinanceExpireLimitUse: '尊敬的用户，您购买的财务管理模块已过期。<br>请续费后继续使用，可联系您的销售人员或联系客服。<br><div style="margin-top: 5px;">财务管理模块将被限制访问，数据将被保留。等续费后，可再次使用。</div>',
  EdiExpireLimitUse: '尊敬的用户，您购买的EDI订舱接口已过期。<br>请续费后继续使用，可联系您的销售人员或联系客服。',
  TaxExpireLimitUse: '尊敬的用户，您未开通税控服务，或购买的税控服务已到期。<br>请续费后继续使用，可联系您的销售人员或联系客服。',
  EntrustPageTab: '委托页签',
  ExportEntrustPageTab: '出口委托页签',
  ImportEntrustPageTab: '进口委托页签',
  AttachmentRuleConfig: '附件规则配置',
  BusinessOrdersAttachments: '业务有形式分单时，附件抽取形式分单',
  SendPackageProxyFiles: '文件历史-发送套单代理文件',
  BillNotStartNoneFile: 'HBL提单状态未开始或待确认时，不抽取任何提单文件（包括样张件）',
  LockAfterSend: '发送后锁定：',
  SendLockSlaveHblAndVirtualBill: '发送后，锁定小票的HBL和形式分单页签（包括拆单/并单）',
  SendLockExchangeAgentHblAndVirtualBill: '发送后，锁定对应换单代理的HBL页签和形式分单页签（包括拆单/并单）',
  AutoPrintManifestAfterAllHblConfirm: '仅在所有HBL提单状态都确认后，自动打印MAINFEST文件（包括HBL拆单）',
  BusinessDataNotUpdate: '更新业务数据时，不自动更新岗位人员',
  AutoPrintRule: '自动打印规则',
  EmailAttachRule: '邮件附件抽取规则',
  FormalDivisionRule: '形式分单规则',
  BusinessIfVirtualBillOnlyAttachment: '业务有形式分单时，附件仅抽取形式分单文件',
  SetFileSyncRule: '设置文件同步规则',
  BusinessModel: '业务模式：',
  SyncDirection: '同步方向：',
  SyncCondition: '同步条件：',
  SyncFileToApprovedDoc: '可同步文件到已审核单据中',
  DeleteFile: '删除文件：',
  SyncMode: '同步模式：',
  CrossDelegation: '交叉委托',
  PrincipalOperator: '委托方->操作方',
  OperatorClient: '操作方->委托方',
  SyncFileDeletion: '同步删除文件',
  NotDeleteRelateFile: '不删除对方文件',
  ManualSync: '手动同步',
  AutoSync: '自动同步',
  ExportToImport: '出口转进口',
  ExporterImporter: '出口方->进口方',
  ImporterExporter: '进口方->出口方',
  BbSendDestinationPortAgent: '委托拼箱发送目的港代理文件',
  ChargeSyncAuditPass: '费用同步-审核通过',
  ChargeSyncAuditNotPass: '费用同步-审核不通过',
  ChargeSyncRecallApplyCharge: '费用同步-撤回申请费用',
  SendEmailByPositionPersonnel: '邮件将推送给对方的设置岗位人员',
  AttachmentItems: '附件项',
  PleaseSetAttach: '请先设置附件项文件类型！',
  SendLockHblAndVirtualBill: '发送后，锁定业务的HBL和形式分单页签（包括拆单/并单）',
  AirOperationTAB: '空运操作页签',
  CurrentPageNewFieldTip: '当前页签有新增字段，请点击编辑后添加字段。',
  SystemAddedItem: '系统新增字段项',
  DragTheBlockUse: '请将字段拖拽到对应的分类块下才可使用',
  CustomTemplateMustSelect: '自定义模板名称必须要选择一个信息',
  VirtualBillHBLNO: '形式分单HB/L NO',
  TemplateRemarks: '模版备注',
  AutomPrintDefaultFileType: '自动打印默认文件类型',
  PopupMode: '弹窗模式',
  DisplayWhenThereIsValidation: '仅在验证有错误信息时显示验证信息弹窗',
  TheBeAppliedToOffices: '弹窗模式会应用于所有的分公司',
  VerificationNodeCannotBeEmpty: '【验证节点】不能为空',
  VerificationModeCannotBeEmpty: '【验证模式】不能为空',
  CustomerOfLadingOptionIssue: '客户自出单（提单勾选客户自出单）',
  WhenLadingHasBeenDocuments: '当有客户自出单文件时，且提单已确认或已签发时，抽取客户自出单',
  WhenIsNeitherConfirmedExtracted: '当有客户自出单文件时，且提单未确认未签发时，不抽取客户自出单',
  WhenOfLadingHasSample: '当没有客户自出单文件时，且提单已确认未签发，自动打印样张',
  ApplicationModule: '应用模块',
  UICustomisation: 'UI自定义',
  SOPPanel: 'SOP面板',
  FileHistoryTab: '文件历史页签',
  ViewOpInstruction: '查看操作指令',
  SetOpInstruction: '设置操作指令',
  HeadquartersSetupForCommandApplications: '指令应用总公司设置',
  SetCommandParameters: '设置指令参数',
  DisplayRuleSettings: '显示规则设置',
  PleaseCommandForAScenario: '请设置一个操作指令。',
  CommandParameters: '指令参数',
  SceneRules: '场景规则',
  SceneParameters: '场景参数',
  CommandApplication: '指令应用',
  TheStatusOfAllProcesses: '按业务发送时，仅在所有HBL状态都确认后，自动打印MAINFEST (包括拆单)',
  WhenOnlyAfterTheConfirmed: '按箱发送时，仅在箱对应的所有HBL状态都确认后，自动打印MAINFEST (包括拆单)',
  TheLettersAndBeLength: '密码必须包含数字、小写字母、大写字母，且长度在8-20 个字符之间',
  WhenIssuesBillOfExtracted: '客户自出单（提单勾选客户自出单）有自出单时，仅抽取客户自出单',
  SetBlockWidth: '设置区块宽度',
  SettableRange300400: '可设置范围：300-400',
  DisplaySettings: '显示设置',
  ApplicationSettings: '应用设置',
  ReadAndWriteSettings: '读写设置',
  CanEditable: '可编辑',
  VisibleToDesignatedPersonnel: '指定人员可见：',
  FieldPermissionSettings: '字段权限设置',
  CanWrite: '可写',
  FieldNameQuery: '字段名称查询',
  TheAsTheOceanConfiguration: '订舱预审字段别名同海运订舱设置，不支持独立设置！',
  TheAsThoseForConfiguration: '海运订舱委托字段别名同海运订舱设置，不支持独立设置！',
  TheAsTheAirConfiguration: '空运订舱委托字段别名同空运订舱设置，不支持独立设置！',
  TheThoseInTheConfiguration: '铁路订舱委托字段别名同铁路操作设置，不支持独立设置！',
  TheOrderInTheConfiguration: '订单预审字段别名同空运订舱设置，不支持独立设置！',
  FillInMode: '填写模式',
  SingleTicketBusinessForm: '单票业务填写',
  BulkProcessing: '批量业务处理',
  SingleFormSubmission: '单票填写表单',
  BatchFillOutForms: '批量填写表单',
  SelectionForm: '选择表单',
  TriggerNodeStatesupConfigured: '触发其他节点状态回滚（最多配置5个）',
  RollbackBeSetOnlyStartedAbnormal: '仅在【状态类型】为【未开始】/ 【异常】时，可设置对其他节点状态的回滚',
  PleaseNodeThatNeedsTriggered: '请设置一个需要触发的回滚节点',
  TheNodeCannotBeEmpty: '节点不能为空',
  TheStatusCannotBeEmpty: '节点状态不能为空',
  AllowStatusToTriggerRollback: '允许该节点状态触发回滚',
  SOPRestrictionsForBusinessDocuments: '业务单据的SOP模板匹配限制',
  OnlyForTheBranchTemplate: '仅设定的应用操作分公司和HQ模板',
  OnlyOperationDepartmentAndTemplate: '仅设定的应用操作部门和HQ模板',
  TabSettings: '页签设置',
  StandardFeesTab: '标准费用页签',
  HideStandardFeeTab: '隐藏标准费用页签',
  DisplayAsASeparateTab: '作为独立页签显示',
  DropdownBoxValueDisplay: '下拉框值显示：',
  DisplayRecentlyUsed50Values: '显示最近使用的前50条数据值',
  DisplayOrderLogic: '显示顺序逻辑：',
  TheFirstValueTheSequentially: '最后一次保存的会作为第一个数据值显示，前一次保存的作为第二个显示，依次显示。',
  InstructionPermissions: '指令权限',
  AllPositions2: '全部岗位',
  PleaseAPositionOrPersonnel: '请选岗位或人员',
  SalesModule: '销售模块',
  SalesInquiry: '销售查询',
  SalesInquiryApplication: '销售查询应用',
  SalesTheCustomTabUI: '销售查询允许显示该UI自定义页签',
  DisplayCargoPackingInformation: '显示装箱货物信息',
  ControlPropertyConfiguration: '控件属性配置',
  WhenMainTicketDisplayMode: '业务单据为主票时，显示主票装箱模式',
  UpdatePortDataButton: '更新港区数据按钮',
  UIFieldConfiguration: 'UI字段配置',
  AutomatedExecution: '自动化执行',
  InvokeAutomatedExecution: '调用自动执行',
  SOPStatusTrigger: 'SOP状态触发',
  TriggerBasedOnFieldValue: '根据字段值触发',
  DocumentInfo: '文档信息',
  DocumentTemplate: '文档模板',
  LocalizedTemplateName: '本地化模板名称',
  TemplateId: '模板ID',
  TemplateStatus: '模板状态',
  TemplateType: '模板类型',
  TemplateDescription: '模板说明',
  LocalizedTemplateDescription: '本地化模板说明',
  ApplicableCarrier: '适用承运人',
  ApplicableSeaport: '适用港口',
  PleaseEnterLocalTemplateName: '请输入本地化模板名称',
  TemplateEnabledPrompt: '【{0}】-【{1}】文件正确，启用后将可能在业务中被用户使用。',
  TemplateDisabledPrompt: '【{0}】-【{1}】禁用后将不可在业务中被用户查找或使用。',
  TemplateDeletedPrompt: '请确认是否已删除【{0}】-【{1}】',
  TriggeredToSpecificBusinessRules: '根据特定业务规则触发',
  InvoiceInquiryTab: '发票查询页签',
  SetFieldValueSynchronization: '设置字段值同步',
  SourceTab: '来源页签',
  SourceField: '来源字段',
  WriteTab: '写入页签',
  WriteField: '写入字段',
  SyncOnlyAtCreation: '仅在创建时同步',
  SynchronizedReceiptWithMainTicket: '主票时同步小票',
  AreWantToDeleteData: '是否确定删除所选数据？',
  TheFieldCannotBeEmpty: '【{0}】字段项不可以为空',
  ConfirmFieldValueSynchronizationConfiguration: '确定保存字段值同步配置？',
  ShippingInformationNonMainInvoice: '装箱信息-非主票',
  ConfirmBatchModification: '是否确认批量修改？',
  PleaseSelectFillModeAndForm: '请选择填写模式，并选择表单!',
  FillFormCannotBeEmpty: '填写表单不能为空！',
  BatchModificationPrompt: '批量修改提示',
  ConfirmBatchModification: '是否确认批量修改？此操作将对选中的所有任务进行批量修改。',
  BatchModificationConfirm: '批量修改确认',
  TemplateApplicationSettings: '模板应用设置',
  MatchingSettings: '匹配设置',
  ManualSOPTemplatesIsAllowed: '不允许手动更换SOP模板',
  DoTemplateIsAutomaticallyTemplate: '当模板自动匹配到新模板时，不显示提示',
  ContainerMaxNumTip: '箱量不能超过【{0}】个，如需更多箱量，请联系客服调整【ContainerMaxNum】参数阈值。',
  BatchOperationSettings: '批量操作设置',
  BatchOperationsSupported: '可批量操作',
  BulkOperationPrompt: '批量操作提示',
  PleaseSelectRailwayExportServices: '请选择铁路出口业务',
  PleaseSelectRailwayImportBusiness: '请选择铁路进口业务',
  BatchAllowedPleaseSelectRecord: '不可批量操作，请勾选单条记录',
  AreWantToPerformOperation: '是否确认批量操作！',
  NonNotSupportCrossTenants: '非集团公司，不支持同租户交叉委托',
  NoBusinessCanBeEntrusted: '没有可以委托的业务',
  PleaseSelect0: '请选择{0}',
  ShippingInformationMasterBill: '装箱信息-主票',
  HideDefaultButton: '隐藏默认按钮',
  AdditionalReceivables: '新增应收',
  AdditionalPayable: '新增应付',
  PartnerPrivilegeManagement: '合作伙伴权限管理',
  SupplierDepartmentPermission: '供应商所属部门权限',
  View: '查看',
  Edit: '编辑'
}
